import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import iconFile from '/icons/image.svg';

export default class ImageFinder extends Plugin {
    init() {
        const editor = this.editor;
        const imageFinderUrl = editor.config.get('imageFinder.url');
        const imageFinderBaseRoot = editor.config.get('imageFinder.baseRoot');

        editor.ui.componentFactory.add('imageFinder', locale => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Image',
                icon: iconFile,
                tooltip: true
            });

            view.on('execute', () => {
                // Behavior to open a new window goes here.
                var width = 1200;
                var height = 600;
                var left = parseInt((screen.availWidth/2) - (width/2));
                var top = parseInt((screen.availHeight/2) - (height/2));
                var windowFeatures = "width=" + width + ",height=" + height + ",status,resizable,left=" + left + ",top=" + top + "screenX=" + left + ",screenY=" + top;
                window.open(imageFinderUrl, "", windowFeatures);

                window.setValue = function (value){
                    editor.model.change( writer => {
                        editor.execute( 'insertImage', { source: value } );
                    });
                }

            });

            return view;
        });
    }
}